import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If, Else } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getScimAudit } from "routes/settings/plugins/scim/controller/get-scim-audit"
import { ActivityRow } from "./activity-row"

export function ActivityLogSection() {
    const { client } = useBoundContext()
    const clientId = client?.id
    const entries = getScimAudit.useResults({ clientId, take: 100 }) ?? []

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Activity log
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                The most recent identity provider events for this tenant — SCIM operations, license reconciles, and
                safeguards. Click any row to see the full actor + before/after state.
            </Typography>

            <If value={entries.length > 0}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: 32 }} />
                            <TableCell>When</TableCell>
                            <TableCell>Event</TableCell>
                            <TableCell>Resource</TableCell>
                            <TableCell>Outcome</TableCell>
                            <TableCell>Detail</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <Repeat list={entries} item={<ActivityRow />} keyFn={entryKeyFn} pass="entry" />
                    </TableBody>
                </Table>
                <Else>
                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                        No activity yet.
                    </Typography>
                </Else>
            </If>
        </Box>
    )
}

function entryKeyFn(e) {
    return e._id
}
